var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("\n\t@"+_vm._s(_vm.user.username)+"\n\t"),_c('span',[_c('a',{on:{"click":function($event){return _vm.deleteSelected(_vm.user)}}},[_c('ion-icon',{attrs:{"name":"ios-close"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81a8833a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/groupsSearch/GroupsSelectedUsers.vue
// module id = null
// module chunks = 